import React from 'react'
import Header from '../../Components/Header/Header'
import Footer from '../../Components/Footer/Footer'
import img1 from '../../assets/course/12101001.jpg'
import img2 from '../../assets/course/12101002.jpg'
import img3 from '../../assets/course/12101003.jpg'
import tr1 from '../../assets/others/11102067.webp'
import img4 from '../../assets/others/11102069.jpg'
import Accordion from 'react-bootstrap/Accordion'
import Companysec from '../../Components/Companysec/Companysec'
import Offersec from '../../Components/Offersec/Offersec'
import icncheck from '../../assets/icons/check-circle-bl.svg'
import instimg from '../../assets/others/11102038.jpg'
import Enrollaction from '../../Components/Enrollaction/Enrollaction'
import "react-multi-carousel/lib/styles.css";
import Partnersec from '../../Components/Partnersec/Partnersec'
import Videoreview from '../../Components/Videoreviewsec/Videoreview'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import Whysec from '../../Components/Whysec/Whysec'
library.add(fas)

const onButtonpdf = () => {
    const pdfUrl = "../../brochuer/Takshila-VLSI-Company-Brochure.pdf";
    window.open(pdfUrl);
};

const PERL = () => {
  return (
    <div>
    <Helmet>
    <title>Perl Scripting Training Course for VLSI Engineers | Takshila VLSI</title>
	<meta name="description" content="Join Perl Scripting training to automate VLSI design and verification workflows through practical, industry-focused sessions with Takshila VLSI." />
	<link rel="canonical" href="https://www.takshila-vlsi.com/product/perl-scripting/" />
	<meta property="og:locale" content="en_US" />
	<meta property="og:type" content="article" />
	<meta property="og:title" content="Perl Scripting Training Course for VLSI Engineers | Takshila VLSI" />
	<meta property="og:description" content="Join Perl Scripting training to automate VLSI design and verification workflows through practical, industry-focused sessions with Takshila VLSI." />
	<meta property="og:url" content="https://www.takshila-vlsi.com/product/perl-scripting/" />
	<meta property="og:site_name" content="Takshila VLSI" />
	<meta property="article:modified_time" content="2021-03-09T13:59:49+00:00" />
	<meta property="og:image" content="https://www.takshila-vlsi.com/wp-content/uploads/2019/12/PERL-Traning-1024x678.jpg" />
	<meta property="og:image:width" content="1024" />
	<meta property="og:image:height" content="678" />
	<meta property="og:image:type" content="image/jpeg" />
	<meta name="twitter:card" content="summary_large_image" />
     </Helmet>
    <Header/>
<main>
    <section class="section-banner pg-banner ws-section pt-5 bg-14">
    <div class="container text-center">
                <div class="row justify-content-around p-lg-5 pb-0">
                    <div class="col-md-9">
                        <div class="pg-title-sec">
                            <h1 className='pg-title pb-3'>PERL 
                            <span className='bg-txt mx-3'>Scripting</span>
                            </h1>
                            <p className='pg-title-desc mb-5'>Takshila VLSI institute is among the top 10 VLSI training institutes in India. At Takshila, we understand the changing demands in the field of VLSI.</p>
                        </div>
                    </div>
                    <div class="col-md-12 align-self-center mb-3">
                            <a href="/register-now">
                                <button class="btn-primary btn-icon">Enroll Now<FontAwesomeIcon icon="fa-solid fa-circle-arrow-right" /></button>
                            </a>
                    </div>
                </div>
                <div class="row justify-content-center img-radius g-3">
                    <div class="col-md-2 align-self-end d-none d-sm-block">
                    <img src={img1} alt=''/>
                    </div>
                    <div class="col-md-2 align-self-end">
                    <div className='course-bnr-bx bg-8 radius-1'>
                            <h4 className='course-bnr-title'>100%</h4>
                            <p className='course-bnr-desc'>Learners feel more confident when applying for jobs</p>
                        </div>
                    </div>
                    <div class="col-md-3 align-self-end">
                    <img src={img2} alt=''/>
                    </div>
                    <div class="col-md-2 align-self-end">
                    <div className='course-bnr-bx bg-7 radius-1'>
                            <h4 className='course-bnr-title'>100%</h4>
                            <p className='course-bnr-desc'>Learners became better at their job</p>
                        </div>
                    
                    </div>
                    <div class="col-md-2 align-self-end d-none d-sm-block">
                    <img src={img3} alt=''/>
                    </div>
                </div>
    </div>
</section>
<section className='course-desc p-lg-5 bg-14'>
        <div class="container text-center">
                <div class="row justify-content-around text-center">
                    <div class="col-md p-5">
                            <h2 className='ws-section_heading pd-03'><span className='font-thin'>PERL Scripting Training / PERL Training
                            </span> Courses in Bangalore/ Hyderabad</h2>
                    </div>
                </div>
                <div class="row justify-content-around">
                    <div class="col-md">
                            <h3 className='pb-3 txt-3'>COURSE DESCRIPTION</h3>
                            <div className='text-left text-xl'>
                            <p>The perl course trains the engineers extensively on the scripting skills used in different fields. This skill is an add-on to the industry skills such as Design Verification Methodologies and help them to join the industry with scripting skills.</p>
                            <p>The key features of the Perl Scripting involves file operations, grepping, pattern match, basic oop, regular expressions and regression run, which are widely used for sampling the logfiles, and test runs in the industry. The scripts make the life of any verification engineer, or designer easy, while working with different files and tons of data processing. The course is designed to have learning by doing, to have goo hold over the concepts.</p>
                            </div>
                    </div>
                </div>
        </div>
</section>
<section className='highlight-section p-lg-5 p-2 bg-14'>
    <div class="container bg-9 p-lg-5 p-3 radius-1">
        <div className='mb-5'>
        <div className='txt-2 mb-2'>Eligibility</div>
        <div class="row">
            <div className='col-lg'>
            <div className='icon-left-bx d-flex'>
                <div className='icn-img'> <img src={icncheck} alt=''/></div>
                <div className='icn-heading'>B.E/B.Tech in ECE/EEE/EIE/CSE/IT
                </div>
            </div>
            </div>
            <div className='col-lg'>
            <div className='icon-left-bx d-flex'>
                <div className='icn-img'> <img src={icncheck} alt=''/></div>
                <div className='icn-heading'>MCA/M.Sc (computers/Electronics).
                </div>
            </div>
            </div>
            <div className='col-lg'>
            <div className='icon-left-bx d-flex'>
                <div className='icn-img'> <img src={icncheck} alt=''/></div>
                <div className='icn-heading'>M.E/M.Tech/M.S in Computer Science streams/Embedded Systems/Electronics streams.
                </div>
            </div>
            </div>
        </div>
        </div>
        <div className='mb-5'>
        <div className='txt-2 mb-2'>Course Duration</div>
        <div class="row">
            <div className='col-lg'>
            <div className='icon-left-bx d-flex'>
                <div className='icn-img'> <img src={icncheck} alt=''/></div>
                <div className='icn-heading'>4 Weeks</div>
            </div>
            </div>
        
        </div>
        </div>
        <div>
        <div className='txt-2 mb-2'>Course Highlights</div>
        <div class="row">
            <div className='col-lg'>
            <div className='icon-left-bx d-flex mb-2'>
                <div className='icn-img'> <img src={icncheck} alt=''/></div>
                <div className='icn-heading'>Covers the PERL regular expression widely used in industry.</div>
            </div>
        
            <div className='icon-left-bx d-flex mb-2'>
                <div className='icn-img'> <img src={icncheck} alt=''/></div>
                <div className='icn-heading'>Regression flow automation.</div>
            </div>
            
            <div className='icon-left-bx d-flex mb-2'>
                <div className='icn-img'> <img src={icncheck} alt=''/></div>
                <div className='icn-heading'>24×7 Lab Support with Lab practice handouts and course material delivery.</div>
            </div>
            
            <div className='icon-left-bx d-flex mb-2'>
                <div className='icn-img'> <img src={icncheck} alt=''/></div>
                <div className='icn-heading'>Industry standard project execution, Lab practice and theory sessions under the guidance of industry expert with 12+ years of experience.
                </div>
            </div>
            
            <div className='icon-left-bx d-flex mb-2'>
                <div className='icn-img'> <img src={icncheck} alt=''/></div>
                <div className='icn-heading'>Soft skills development, complete suite of job oriented ASIC Verification training with 100% placement assistance.</div>
            </div>
            
            </div>
        </div>
        </div>
            
    </div>
</section>

<section className='author-section p-lg-5 p-2 bg-14'>
      <div className='container'>
      <div class="row">
              <div class="col-lg-9 align-self-center bg-3 dark-bg p-lg-5 mr--10 mt-5 p-3 mb-3">
              <h2 class="ws-section_heading mb-3">About Instructors</h2>
              <a href='/teachers/rajiv/'><h4>Mr. Rajiv</h4></a>
              <h6 className='pb-3'>(ASIC Verification Specialist)</h6>
              <p>Mr. Rajiv comes with a 13+ years of rich experience in Design Verification in IP, Sub-System and SoC levels. Working experience in multiple protocol-lgs like PCIe, USB, SATA, DDR, Ethernet etc, and also he has working experience in both ASIC and FPGA design flows. We believe his solid knowledge on Digital and Advaced System Architectures adopted by industry helps the students to shape themselves as good VLSI engineers.
              </p>
              
              <div class="wpb_wrapper"><p>We believe his solid knowledge on Digital and Advaced System Architectures adopted by industry helps the students to shape themselves as good VLSI engineers.</p>
              <div class="row g-3">
                      <div class="col-lg m-lg-3 p-4 bg-white radius-1">
                      <p><strong>Skills:</strong><br/>
                        Verilog, VHDL,<br/>
                        System Verilog<br/>
                        UVM, OVM, VMM<br/>
                        PERL
                        </p>
                      </div>
                      <div class="col-lg m-lg-3 p-4 bg-white radius-1">
                      <p><strong>Protocol-lgs Worked On:</strong><br/>
                        PCIe, USB, SATA, DDR, Ethernet<br/>
                        AMBA Protocol-lgs</p>
                  
                      </div>
                      <div class="col-lg m-lg-3 p-4 bg-white radius-1">
                      <p><strong>Tools:</strong><br/>
                        ModelSim, VCS, IRUN<br/>
                        Quartus II (Altera FPGA Development Platform)</p>
                      </div>
                  </div>
                </div>
              </div>
              <div class="col-lg img-radius">
              <img src={instimg} alt=''/>
              </div>
          </div>
          </div>
      </section>

<section className='curriculum-section pt-5'>
    <div className='container'>
        <div class="row justify-content-center mb-5">
        <div class="col-lg-8 text-center">
        <h3 class="ws-section_heading pb-03 txt-3">PERL Scripting Training Institute in Bangalore
        </h3>
        </div>
        </div>
        <div class="row mb-5">
            <div class="col-lg-8">
            <div class="ws-section_heading pb-03 txt-3 mb-lg-0">Course Curriculum</div>
            </div>
            <div class="col-lg-4 align-self-center">
            <button class="btn-primary btn-icon" onClick={onButtonpdf}>Download Brochure<FontAwesomeIcon icon="fa-solid fa-circle-arrow-right" /></button>
            
            </div>
        </div>
        <div className='row'>
            <div className='col-lg'>
            <div className='curriculum-accord accordion'>
                    <Accordion defaultActiveKey="0">
                    <Accordion.Item eventKey="0">
                        <Accordion.Header>Module 1: PERL (Practical Extracting Report Language)</Accordion.Header>
                        <Accordion.Body>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>PERL Introduction </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>PERL Basic Syntax</div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Commenting </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Perl_-_Whitespace_Quotes_Escapesequences </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>PERL Data types  </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>PERL Scalars </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>PERL Arrays </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Perl_-_Arrays_Slicing___Splice_Function </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Perl Split & Join </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Perl_-_Sort_Array,_$_and_Merging </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Perl Hashes </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Perl Chomp and Chop </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Perl Map and Grep  </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Types of Variable Scopes  </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Strict and Warnings  </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Decision Conditioning </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Loops </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Operator </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Subroutines  </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>References </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Array of array </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Hashes of arrays  </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Arrays of hashes </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Hashes of hashes </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Hashes of complex records </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Formats </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>File IO Operations  </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Directories </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Error handling  </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Packages and modules  </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Regular expressions </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Sending email </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Special variables </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Calling method </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>DBI access </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Creating objects in OOP </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Eval Function </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Inheritance </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Installing CPAN module </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Process management  </div>
                        </div>
                        <div className='icon-left-bx d-flex mb-2'>
                            <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                            <div className='icn-heading'>Regression  </div>
                        </div>
                    </Accordion.Body>
                    </Accordion.Item>
                    
                    

                    </Accordion>
                    </div>
            </div>
        </div>

    </div>
            </section>

            <Companysec/>
<Whysec/>           
<Offersec/>


<section className='ws-section pb-5 bg-white'>
    <div class="container text-center">
    <div className='row pb-3'>
            <div className='col-lg text-center'>
            <h2 class="ws-section_heading">Connect With Us</h2>
        </div>
        </div>
    <div class="row justify-content-around">
                    <div class="col-lg-5">
                        <div className='trainer-box'>
                            <div className='content-box wd-80 d-flex bg-path'>
                            <div className='trainer-content'>
                            <h5 className='trainer-title text-left'>Join us & achieve <br/>
                            your goals.</h5>
                            </div>
                            </div>
                            <div className='trainer-img img-radius mb-3'>
                            <img src={img4} alt=''/>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        
                        <iframe
                            aria-label='Register Now'
                            width="100%"
                            height="850"
                            src={`https://forms.zohopublic.in/takshilavlsi/form/RegisterNow/formperma/tlJf9hR_tSfj9rMVkXThsxg_XdK_F2MPKQIOi3mqwE4`}
                            frameborder="0" 
                        
                        />
                    
                    </div>
                </div>
    </div>
</section>


<section className='course-faq-section ws-section p-lg-5 bg-14'>
    <div className='container'>
        
        <div class="row justify-content-center mt-5">
                <div class="col-lg-9">
                    <div class="callaction-2">
                        <div class="row g-3">
                        <div class="col-lg-7">
                            <h2>Don't see your questions ? answered here?</h2>
                        </div>
                        <div class="col-lg-4 align-self-center text-center">
                        <a href="/contact-us/">
                        <button class="btn-primary btn-icon ms-0" href="index.html#about">Contact Us<FontAwesomeIcon icon="fa-solid fa-circle-arrow-right" /></button>
                        </a>
                        </div>
                        </div> 
                    </div>
                </div>
            </div>
    </div>
</section>


<Videoreview/>
<Enrollaction/>
<Partnersec/> 
</main>
<Footer/>
</div>
  )
}

export default PERL